import DOMPurify from "dompurify";
import {useState} from "react";
import {renderToString} from "react-dom/server";

import Button from "@/components/button/Button.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";

import {BrowserConsoleMessageIcon} from "./BrowserConsoleMessageIcon.tsx";

import styles from "./ConsoleOutputModal.module.css";

interface ConsoleLine {
  // eslint-disable-next-line typescript/no-explicit-any
  file: any;
  message: string;
  type: string;
  line: number;
}

interface ConsoleOutputModalProps {
  items: ConsoleLine[];
}

export const ConsoleOutputModal = ({items}: ConsoleOutputModalProps) => {
  const [showModal, setShowModal] = useState(false);
  const output_items = items.map(function (e, i) {
    if (e.file) {
      e.file = e.file.split("/");
      e.file = e.file[e.file.length - 1];
    }

    return (
      <li className={e.type} key={`console-output-${i}`}>
        {e.file && (
          <div className="file-and-line float-right">
            {e.file} (line {e.line})
          </div>
        )}
        <BrowserConsoleMessageIcon className="me-2" type={e.type} />
        <span>{e.message}</span>
      </li>
    );
  });
  const output = <ul className="browser-console-output">{output_items}</ul>;
  const innerHTML = renderToString(output);
  return (
    <div className="browser-console-output btn-group dropup">
      <ActionDialog
        onConfirm={() => setShowModal(false)}
        size="xl"
        title="Console Output"
        show={showModal}
        confirmBtnText="OK"
        onCancel={() => setShowModal(false)}
        hasCancelButton={false}
      >
        <div className={styles.consoleOutput} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(innerHTML)}} />
      </ActionDialog>
      <Button
        className="mt-3"
        size="fitContent"
        variant="ghost"
        onClick={() => {
          setShowModal(true);
        }}
      >
        View Console
      </Button>
    </div>
  );
};
